import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";
import { useUserActiveOrganization } from "../user/useUserActiveOrganization";

const ORGANIZATION_APP_SESSIONS = gql(`
  query organizationAppSessions($organizationSlug: String!, $after: ID, $first: Int, $filter: OrganizationAppSessionsFilterInput){
    organization(organizationSlug: $organizationSlug) {
      ... on Organization {
        __typename
        id
        appSessions(after: $after, first: $first, filter: $filter) {
          __typename
          edges {
            __typename
            cursor
            node {
              __typename
              id
              app {
                __typename
                id
                displayName
              }
              ownerOrganization
              userId
              userEmail
              accessType
              startTime
              endTime
            }
          }
          pageInfo {
            __typename
            hasNextPage
            startCursor
            endCursor
          }
        }
      }
    }
  }
`);

export type OrganizationAppSessionsQueryResult =
  typeof useOrganizationAppSessions;

export function useOrganizationAppSessions() {
  const { activeOrganization } = useUserActiveOrganization();

  const { data, ...rest } = useQuery(ORGANIZATION_APP_SESSIONS, {
    variables: { organizationSlug: activeOrganization?.slug || "" },
    skip: !activeOrganization
  });

  const appSessions =
    data?.organization.__typename === "Organization"
      ? data.organization.appSessions
      : undefined;

  return { ...rest, data: appSessions };
}
